import { cn } from '@/shared/lib/cn';
import { AVAILABILITY_SHORT, AVAILABILITY_TONE, type AvailabilityState } from './AvailabilityCard';
import { shortDay } from './helpers';

interface Props {
  name: string;
  from: string;
  to: string;
  /** 0: noch kein gültiger Zeitraum. */
  nights: number;
  adults: number;
  /** Kurzstand der Prüfung; erst mit Apartment und Zeitraum. */
  state: AvailabilityState | null;
}

/** Kopf des Panels: Apartment, Zeitraum, Nächte und Personen, rechts der Stand der Prüfung. */
export function ManualBookingSummary({ name, from, to, nights, adults, state }: Props) {
  return (
    <div className="bg-paper rounded-tile flex flex-wrap items-center gap-3 p-3.5">
      <span className="bg-forest-deep rounded-square inline-flex h-[42px] items-center px-3 font-serif font-bold text-white">
        {name}
      </span>
      <span className="min-w-0 flex-1 text-[13px]">
        <b>{nights > 0 ? `${shortDay(from)} → ${shortDay(to)}` : 'Zeitraum wählen'}</b>
        <span className="text-ink-soft block">
          {nights > 0
            ? `${nights} ${nights === 1 ? 'Nacht' : 'Nächte'} · ${adults} ${adults === 1 ? 'Erwachsener' : 'Erwachsene'}`
            : 'Abreise muss nach der Anreise liegen'}
        </span>
      </span>
      {state && (
        <span
          className={cn(
            'rounded-pill border px-3.5 py-1.5 text-[13px] font-extrabold',
            AVAILABILITY_TONE[state],
          )}
        >
          {AVAILABILITY_SHORT[state]}
        </span>
      )}
    </div>
  );
}
